import {
  entityKey,
  sideKey,
  statusKey,
  yesNoKey,
} from '../../../lib/shared-value-keys';

export const amlInfoKey = [
  {
    label: 'Priority',
    varName: 'Priority',
    key: {
      1: 'High',
      2: 'Medium',
      3: 'Low',
    },
  },
  {
    label: 'Account #',
    varName: 'AccountNumDisplay',
    decryptTarget: 'EncryptedAccountID',
  },
  { label: 'Rep Code', varName: 'RepID' },
  { label: 'Rep Name', varName: 'RepName' },
  { label: 'Client Name', varName: 'ClientFullName' },
  { label: 'Client SSN', varName: 'MaskedSSN' },
  { label: 'Date Generated', varName: 'ProcessedDate', valueMask: 'date' },
  { label: 'Status', varName: 'ReviewStatus', key: statusKey },
  { label: 'Reviwer ID', varName: 'ReviewerID' },
  { label: 'Review Date', varName: 'ReviewDate' },
];
export const accountKey = [
  {
    label: 'Account #',
    varName: 'AccountNumDisplay',
    decryptTarget: 'EncryptedAccountID',
  },
  {
    label: 'Opened',
    varName: 'OpenDate',
    valueMask: 'date',
  },
  {
    label: 'Balance',
    varName: 'Balance',
    valueMask: 'currency',
  },
  { label: 'Account Type', varName: 'AccountType' },
  { label: 'Registration', varName: 'Registration' },
  { label: 'Tax Status', varName: 'TaxStatus' },
  {
    label: 'Employee Owned',
    varName: 'EmployeeOwned',
    key: yesNoKey,
  },
  { label: 'ROA Number', varName: 'ROANumber' },
  {
    label: 'LOI Number',
    varName: 'CumulativeDiscountNum',
  },
  {
    label: 'Compensation Type',
    varName: 'CompType',
    key: {
      C: 'Commission',
      F: 'Fee',
    },
  },
  {
    label: 'Work/Application #',
    varName: 'WorkID',
  },
  {
    label: 'Objective',
    varName: 'ObjectiveDisplay',
  },
  {
    label: 'Risk Tolerance',
    varName: 'RiskToleranceDisplay',
  },
  {
    label: 'Time Horizon',
    varName: 'TimeHorizonDisplay',
  },
  {
    label: 'Liquidity Needs',
    varName: 'LiquidityNeedsDisplay',
  },
];
export const suitabilityKey = [
  {
    label: 'Primary Acccount Holder',
    varName: 'IsPrimary',
    valueMask: 'translateBool',
  },
  {
    label: 'Entity Type',
    varName: 'EntityType',
    key: entityKey,
  },
  { label: 'SSN/TIN', varName: 'MaskedSSN' },
  { label: 'Age', varName: 'Age' },
  { label: 'State of Residence', varName: 'ResidentState' },
  {
    label: 'Liquid Net Worth',
    varName: 'LiquidNetWorthDisplay',
  },
  {
    label: 'Net Worth',
    varName: 'NetWorthDisplay',
  },
  {
    label: 'Income',
    varName: 'IncomeDisplay',
  },
  {
    label: 'Tax Bracket',
    varName: 'TaxBracket',
    valueMask: 'percent',
  },
];
export const keyMetricsKey = [
  {
    label: 'Recent Deposits',
    varName: 'RecentDeposits',
    valueMask: 'currency',
  },
  {
    label: 'Recent Withdrawals',
    varName: 'RecentWithdrawals',
    valueMask: 'currency',
  },
  {
    label: 'Deposit to Income Ratio',
    varName: 'DepositToIncome',
    valueMask: 'percent',
  },
  {
    label: 'Deposit to Net Worth Ratio',
    varName: 'DepositToNW',
    valueMask: 'percent',
  },
  {
    label: 'Microcap Concentration',
    varName: 'MicrocapConcentration',
    valueMask: 'percent',
  },
  {
    label: 'Cash Concentration',
    varName: 'CashConcentration',
    valueMask: 'percent',
  },
  {
    label: 'Recent Wire Count',
    varName: 'RecentWireCount',
  },
  {
    label: 'Highest Recent Wire Value',
    varName: 'RecentHighWire',
    valueMask: 'currency',
  },
  {
    label: 'Common Trade Alert',
    varName: 'CommonTMAlert',
  },
  {
    label: 'Common Account Alert',
    varName: 'CommonAMAlert',
  },
  {
    label: 'Common Rep Alert',
    varName: 'CommonFPMAlert',
  },
];
export const amlReviewKey = [
  {
    label: 'Date Updated',
    varName: 'DateUpdated',
  },
  {
    label: 'Status',
    varName: 'NewStatus',
    key: statusKey,
  },
  {
    label: 'Reviewer ID',
    varName: 'ReviewerID',
  },
];
export const caseHistoryKey = [
  { label: 'Case ID', varName: 'CRID' },
  { label: 'Open Date', varName: 'StatusDate', valueMask: 'date' },
  { label: 'Status', varName: 'StatusName' },
];
export const tradeHistoryKey = [
  { label: 'Account #', varName: 'AccountNumDisplay' },
  { label: 'Trade Date', varName: 'TradeDate', valueMask: 'date' },
  {
    label: 'Side',
    varName: 'Side',
    key: sideKey,
  },
  {
    label: 'Product Type',
    varName: 'ProductType',
    key: {
      MF: 'Mutual Funds',
      VA: 'Variable Annuity',
      SPI: 'SPIA',
      FA: 'Fixed Annuity',
      RIL: 'RILA',
      FIA: 'Fixed Indexed Annuity',
    },
  },
  { label: 'Security ID', varName: 'SecID' },
  { label: 'Product Name', varName: 'ProductName' },
  { label: 'Amount', varName: 'Amount', valueMask: 'currency' },
  { label: 'Rep Code', varName: 'RepCode' },
  {
    label: 'Commission ($)',
    varName: 'CommissionDollars',
    valueMask: 'currency',
  },
];
export const moneyMovementKey = [
  { label: 'Account #', varName: 'AccountNumDisplay' },
  { label: 'Amount', varName: 'Amount', valueMask: 'currency' },
  {
    label: 'Direction',
    varName: 'Direction',
    key: {
      IN: 'Money In',
      OUT: 'Money Out',
      REV: 'Reversal',
    },
  },
  {
    label: 'Type',
    varName: 'MoneyMovementType',
    key: {
      W: 'Wire',
      C: 'Check',
      J: 'Journal',
      R: 'Real-Time',
      G: 'Generic/ACH',
      O: 'Other/Unknown',
    },
  },
  { label: 'Settlement Date', varName: 'SettlementDate', valueMask: 'date' },
  {
    label: 'Counter Party Type',
    varName: 'CounterPartyType',
    key: {
      I: 'Internal',
      E: 'External',
      O: 'Other/Unknown',
    },
  },
  { label: 'Currency Code', varName: 'CurrencyCode' },
];

export const allClientAccountsKey = [
  { label: 'Account Number', varName: 'AccountNumDisplay' },
  { label: 'Owner', varName: 'OwnerName' },
  { label: 'Owner Age', varName: 'OwnerAge' },
  { label: 'Account Type', varName: 'AccountTypeDisplay' },
  { label: 'Registration', varName: 'Registration' },
  { label: 'Tax Status', varName: 'TaxStatus' },
  { label: 'Balance ($)', varName: 'Balance' },
  { label: 'Objective', varName: 'Objective' },
  { label: 'Risk Tolerance', varName: 'RiskTolerance' },
  { label: 'Time Horizon', varName: 'TimeHorizon' },
  { label: 'Open Date', varName: 'OpenDate', valueMask: 'date' },
];

export const repHistoryKey = [
  {
    label: 'Rep ID',
    varName: 'RepID',
  },
  {
    label: 'Status',
    varName: 'ReviewStatus',
    key: statusKey,
  },
  {
    label: 'Name',
    varName: 'RepName',
  },
  {
    label: 'Alert Count',
    varName: 'AlertCount',
  },
  {
    label: 'Processed Date',
    varName: 'ProcessedDate',
    valueMask: 'date',
  },
  {
    label: 'Reviewer ID',
    varName: 'ReviewerID',
  },
  {
    label: 'Reviewer Name',
    varName: 'ReviewerName',
  },
  {
    label: 'Review Date',
    varName: 'ReviewDate',
    valueMask: 'date',
  },
];
